(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.CompoundInterestEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var DEFAULT_COMPOUND_FREQUENCY = 12;

  // A share link or a hand-edited query string can carry a frequency that is
  // not a positive integer. Left unguarded that produced NaN periods: the
  // balance froze at the principal and total interest went deeply negative.
  function normalizeCompoundFrequency(value) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return DEFAULT_COMPOUND_FREQUENCY;
    }
    return parsed;
  }

  function calculate(input) {
    var P = input.principal;
    var PMT = input.monthlyContribution;
    var r = input.interestRate / 100;
    var n = normalizeCompoundFrequency(input.compoundFrequency);
    var t = input.years;

    var yearlyData = [];
    var balance = P;
    var totalContributions = P;

    var balanceHistory = [P];
    var contributionHistory = [P];
    var interestHistory = [0];

    for (var year = 1; year <= t; year++) {
      var startBalance = balance;
      var yearlyContributions = PMT * 12;
      totalContributions += yearlyContributions;

      // The year's contributions are split evenly across the compounding
      // periods and deposited at the end of each one, whatever the frequency.
      // Previously only monthly and daily deposited inside the loop; annual,
      // semi-annual, and quarterly added one lump after all compounding, so
      // those contributions earned nothing in the year they were made.
      var periodContribution = yearlyContributions / n;
      var endBalance = startBalance;
      for (var period = 0; period < n; period++) {
        endBalance *= (1 + r / n);
        endBalance += periodContribution;
      }

      var interestEarned = endBalance - startBalance - yearlyContributions;

      yearlyData.push({
        year: year,
        startBalance: startBalance,
        contributions: yearlyContributions,
        interest: interestEarned,
        endBalance: endBalance
      });

      balance = endBalance;
      balanceHistory.push(balance);
      contributionHistory.push(totalContributions);
      interestHistory.push(balance - totalContributions);
    }

    var finalBalance = balance;
    var totalInterest = balance - totalContributions;
    var ruleOf72 = input.interestRate <= 0 ? null : (72 / input.interestRate);

    return {
      finalBalance: finalBalance,
      totalContributions: totalContributions,
      totalInterest: totalInterest,
      ruleOf72: ruleOf72,
      yearlyData: yearlyData,
      chart: {
        labels: Array.from({ length: input.years + 1 }, function (_, i) { return i; }),
        balanceHistory: balanceHistory,
        contributionHistory: contributionHistory,
        interestHistory: interestHistory
      }
    };
  }

  return {
    DEFAULT_COMPOUND_FREQUENCY: DEFAULT_COMPOUND_FREQUENCY,
    normalizeCompoundFrequency: normalizeCompoundFrequency,
    calculate: calculate
  };
});
